export default function Header() {
    return (
        <header class="flex flex-col lg:flex-row items-center justify-center lg:justify-between pb-3 mt-4 gap-2 max-w-[95%] lg:max-w-7xl mx-auto">
            <a href="/"><div class="flex gap-2 items-center">
                <img src="/img/heart-couple-logo.png" alt="logo" class="w-14 h-14" />
                <span class="text-3xl font-bold">Nossas memórias - Couple Game</span>
            </div>
            </a>
            <div class="flex items-center justify-center lg:justify-start gap-4 text-xs w-48 z-50">
            </div>
        </header>
    );
}